import React, { createContext, useState, useEffect, useContext } from 'react';
import API from '../api';

// Creazione del Context
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Recupera lo stato dell'utente dal localStorage al primo caricamento
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');
    
    // Se abbiamo sia user che token, usiamo i dati salvati
    if (storedUser && storedToken) {
      return JSON.parse(storedUser);
    }
    
    // Se non abbiamo entrambi, puliamo tutto
    if (!storedUser || !storedToken) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }
    
    return null;
  });
  const [loading, setLoading] = useState(false); // Inizia con false se abbiamo dati salvati

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      const storedUser = localStorage.getItem('user');
      
      // Se non abbiamo token, non facciamo nulla
      if (!token) {
        setLoading(false);
        return;
      }

      // Se abbiamo già i dati utente salvati, verifichiamo solo se necessario
      if (storedUser) {
        // Verifica il token solo se è scaduto o se non abbiamo dati recenti
        const userData = JSON.parse(storedUser);
        const tokenExp = userData.tokenExp || 0;
        const now = Date.now();
        
        // Se il token non è scaduto, usiamo i dati salvati
        if (tokenExp > now) {
          setUser(userData);
          setLoading(false);
          return;
        }
      }

      // Altrimenti verifichiamo il token
      setLoading(true);
      try {
        const res = await API.get('/auth/verify', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res.data.success) {
          const userData = {
            ...res.data.user,
            tokenExp: Date.now() + (24 * 60 * 60 * 1000) // 24 ore
          };
          setUser(userData);
          localStorage.setItem('user', JSON.stringify(userData));
        } else {
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          setUser(null);
        }
      } catch (error) {
        console.error('Errore nella verifica del token:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setUser(null);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = (userData, token) => {
    const userWithExp = {
      ...userData,
      tokenExp: Date.now() + (24 * 60 * 60 * 1000) // 24 ore
    };
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userWithExp));
    setUser(userWithExp);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      logout,
      isLoggedIn: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  return useContext(AuthContext);
}
